import React, { Component, useEffect, useRef, useState } from "react"
import DataCenter, { KLineColor, CurrentCurrency, Connections, generatedKLineDataList } from "../modules/DataCenter";
import { JSEvent, Events } from "../utils/JSEvent";
import { useSpring, animated } from "react-spring";
import useMeasure from "react-use-measure";
import { ArrowNarrowLeftIcon } from "@heroicons/react/solid";
import TabMenu from "../components/TabMenu";
import { colors } from "@react-spring/shared";
import { GlobalSetting, KLineTimeRange, MarketDetailTypes, MarketRecentDataLength, Topics } from "../conf/Config";
import { LoadingDialog, MarketSymbolPanel } from "../components/CommonComponents";
import { request } from "../utils/request";
import API from "../conf/API";
import Selector from "../components/control/Selector";
import WebSocketClient from "../modules/WebSocketClient";
import Button from "../components/control/Button";
import { init, dispose } from 'klinecharts'
import BaseView from "../components/BaseViewComponent";
import { LongTimeToDateStr, LongTimeToFullStr, LongTimeToFullStrNoMin } from "../utils/Utils";
import { LoadingSVG } from "../components/Svgs";

export default class MarketView extends BaseView {
    constructor(props) {
        super(props)
        this.controller = this.props.controller;

        this.initState({
            dataReady: {
                wallet: DataCenter.hasWalletData(),
                symbol: DataCenter.hasSymbolData(),
                thumb: DataCenter.hasThumbData()
            },
        })

        this.onDataReady = this.onDataReady.bind(this);
    }

    componentDidMount() {
        super.componentDidMount?.();
        JSEvent.on(Events.DataCenter.DATA_UPDATED, this.onDataReady);
        this.controller.init();
    }

    componentWillUnmount() {
        super.componentWillUnmount?.();
        JSEvent.remove(Events.DataCenter.DATA_UPDATED, this.onDataReady)
        this.controller.destroy();
    }

    onDataReady(dataName) {
        this.state.dataReady[dataName] = true;

        let allReady = true;
        for (const dn in this.state.dataReady) {
            const dr = this.state.dataReady[dn];
            if (dr == false) {
                allReady = false;
                break;
            }
        }
        if (allReady) {
            this.forceUpdate();
        }
    }

    showMarketDetail(coinSymbol) {
        this.setState({ move: -1, currSymbol: coinSymbol })
        this.addView(MarketSymbolDetail, "right", null, null, {
            symbolSpec: coinSymbol,
            onBackButtonClicked: () => {
                this.hideMarketDetail();
            }
        })
    }

    hideMarketDetail() {
        this.setState({ move: 1 })
    }

    render() {

        const { symbol } = DataCenter;
        let marketData = [];

        if (DataCenter.hasThumbData()) {
            const l = symbol.exchangePairs.length;
            for (let i = 0; i < l; i++) {
                const coinSymbol = symbol.exchangePairs[i];
                const coinThumb = DataCenter.getCoinPairThumb(coinSymbol.id);
                marketData.push(
                    <MarketSymbolPanel
                        key={coinSymbol.id}
                        thumb={coinThumb}
                        symbolSpec={coinSymbol}
                        onClick={() => this.showMarketDetail(coinSymbol)}
                    />)
                if (i < l - 1)
                    marketData.push(<div className='w-full h-[1px] bg-gray-100 mb-3' key={coinSymbol.id + 100000000} />)

            }
        }

        return (
            <div className="flex flex-row flex-1">
                <div className="flex flex-col w-screen h-full flex-1 bg-gray-100">
                    <div className="flex flex-row h-6 m-3">
                        <div className="flex text-gray-400 w-24">名称</div>
                        <div className="flex text-gray-400 flex-1 justify-end">最新价</div>
                        <div className="flex text-gray-400 w-32 justify-end pr-2">24h涨跌</div>
                    </div>
                    <div className="flex flex-col w-full flex-1 rounded-t-2xl bg-white">
                        <div className="flex flex-col w-full flex-1 overflow-y-scroll basis-0 mt-3">
                            <div className="flex flex-col pl-3 pr-3 pb-3">
                                {marketData}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <MarketSymbolDetail move={this.state.move}
                    symbolSpec={this.state.currSymbol}
                    onBackButtonClicked={() => {
                        this.hideMarketDetail();
                    }} /> */}

                {this.state.views}
            </div>
        );
    }
}

function BottomButtons({ move, onClick }) {
    const h = move == -1 ? 64 : 0;
    const styles = useSpring({
        to: { height: h },
    })

    return <div className="flex justify-end items-start bg-gray-100 w-full h-16 left-0 bottom-0 overflow-hidden" >
        <div className="flex pl-4 pt-2 flex-1 justify-start">
            <div className={"flex justify-center items-center w-28 h-10 rounded-md text-white bg-gray-400"} onClick={() => onClick("back")}>返回</div>
        </div>
        <div className="flex pr-4 pt-2 justify-end">
            <div className={"flex justify-center items-center w-28 h-10 rounded-md text-white bg-price-up"} onClick={() => onClick("buy")}>买入</div>
            <div className={"flex ml-2 justify-center items-center w-28 h-10 rounded-md text-white bg-price-down"} onClick={() => onClick("sell")}>卖出</div>
        </div>
    </div>
}

const types = [
    { key: 'candle_solid', text: '蜡烛实心' },
    { key: 'candle_stroke', text: '蜡烛空心' },
    { key: 'candle_up_stroke', text: '蜡烛涨空心' },
    { key: 'candle_down_stroke', text: '蜡烛跌空心' },
    { key: 'ohlc', text: 'OHLC' },
    { key: 'area', text: '面积图' }
]

const rangeField = [
    { key: 0, name: "分时", text: "分时", range: "1min", formatTime: LongTimeToFullStrNoMin },
    { key: 1, name: "1分", text: "1分", range: "1min", formatTime: LongTimeToFullStrNoMin },
    { key: 2, name: "15分", text: "15分", range: "15min", formatTime: LongTimeToFullStrNoMin },
    { key: 3, name: "30分", text: "30分", range: "30min", formatTime: LongTimeToFullStrNoMin },
    { key: 4, name: "1小时", text: "1小时", range: "1hour", formatTime: LongTimeToFullStrNoMin },
    { key: 5, name: "2小时", text: "2小时", range: "2hour", formatTime: LongTimeToFullStrNoMin },
    { key: 6, name: "4小时", text: "4小时", range: "4hour", formatTime: LongTimeToFullStrNoMin },
    { key: 7, name: "1日", text: "1日", range: "1day", formatTime: LongTimeToDateStr },
    { key: 8, name: "1周", text: "1周", range: "1week", formatTime: LongTimeToDateStr },
    { key: 9, name: "1月", text: "1月", range: "1mon", formatTime: LongTimeToDateStr },
]

const techInd = [
    { key: 0, text: "MA", checked: true, type: "main", column: 0 },
    { key: 1, text: "EMA", checked: false, type: "main", column: 0 },
    { key: 2, text: "BOLL", checked: false, type: "main", column: 0 },
    { key: 3, text: "VOL", checked: false, column: 1 },
    { key: 4, text: "MACD", checked: false, column: 1 },
    { key: 5, text: "RSI", checked: false, column: 1 },
    { key: 6, text: "KDJ", checked: false, column: 1 },
]

function SymbolKLine({ symbol, enabled = false }) {

    const klineRef = useRef(0);
    const [loading, setLoading] = useState(true);
    const [kLineData, setKLineData] = useState([]);
    const [timeRange, setTimeRange] = useState(rangeField[GlobalSetting.Setting.KLineTimeRangeSelected]);
    const [tiSetting, setTiSetting] = useState(GlobalSetting.Setting.TechnicalIndicatorSetting);

    for (let i = 0; i < techInd.length; i++) {
        if (techInd[i].type == "main") {
            techInd[i].checked = tiSetting.main == techInd[i].text;
        } else {
            techInd[i].checked = tiSetting.sub[techInd[i].text];
        }
    }

    const toKLineData = (netData, time) => {
        const d = netData.d;
        const kd = {
            open: parseFloat(d[0]),
            close: parseFloat(d[1]),
            high: parseFloat(d[2]),
            low: parseFloat(d[3]),
            volume: parseFloat(d[4]),
            turnover: parseFloat(d[5]),
            timestamp: time == null ? netData.time : time
        };
        return kd;
    }

    useEffect(() => {
        if (enabled) {
            setLoading(true);
            request(API.market_klineHistory(symbol.id, timeRange.range)).then(ret => {
                //根据服务器数据，生成K线数据
                const range = KLineTimeRange[timeRange.range];
                const data = ret.retObject;

                let klineData = [];
                if (data.length > 0) {
                    if (timeRange.range == "1mon") {
                        //月线单独处理
                        data.forEach(d => {
                            klineData.push(toKLineData(d));
                        })
                    } else {
                        const first = data[0];
                        const end = data[data.length - 1];

                        console.log("get kline data from ", LongTimeToFullStrNoMin(first.time),
                            "to ", LongTimeToFullStrNoMin(end.time))

                        klineData.push(toKLineData(first));
                        let dataIdx = 1;
                        let curr = first;

                        for (let time = first.time + range; time <= end.time; time += range) {
                            const p = data[dataIdx];
                            if (p.time > time) {
                                klineData.push(toKLineData(curr, time));
                            } else {
                                curr = p;
                                klineData.push(toKLineData(p));
                                dataIdx++;
                            }
                        }
                    }
                }

                setKLineData(klineData);
                setLoading(false);
            })
            //订阅k线更新topic
            const topic = Topics.market_kLineData(symbol.name, timeRange.range);
            Connections.market.subscribe(topic, onKLineUpdated);

            return () => {
                const topic = Topics.market_kLineData(symbol.name, timeRange.range);
                Connections.market.unsubscribe(topic, onKLineUpdated);
            }
        }

    }, [enabled, timeRange])

    const subTICount = () => {
        let c = 0;
        for (const key in tiSetting.sub) {
            if (tiSetting.sub[key]) {
                c++;
            }
        }
        return c;
    }

    const subIndicatorHeight = () => {
        const c = subTICount();
        switch (c) {
            case 0:
            case 1:
                return 60;
            case 2:
                return 50;
            default:
                return 40;
        }
    }

    useEffect(() => {
        if (loading) return;

        let technicalIndicators = {
            MA: {
                paneId: "", name: { name: 'MA', precision: symbol.quoteCoinDecimal, },
                config: { id: 'candle_pane' }, open: tiSetting.main == "MA" && timeRange.name != "分时"
            },
            EMA: {
                paneId: "", name: { name: 'EMA', precision: symbol.quoteCoinDecimal, },
                config: { id: 'candle_pane' }, open: tiSetting.main == "EMA" && timeRange.name != "分时"
            },
            BOLL: {
                paneId: "", name: { name: 'BOLL', precision: symbol.quoteCoinDecimal, },
                config: { id: 'candle_pane' }, open: tiSetting.main == "BOLL" && timeRange.name != "分时"
            },
            VOL: {
                paneId: "", name: { name: 'VOL', precision: symbol.quoteCoinDecimal, },
                config: { height: subIndicatorHeight() }, open: tiSetting.sub.VOL == true
            },
            MACD: {
                paneId: "", name: { name: 'MACD', precision: symbol.quoteCoinDecimal, },
                config: { height: subIndicatorHeight() }, open: tiSetting.sub.MACD == true
            },
            RSI: {
                paneId: "", name: { name: 'RSI', precision: symbol.quoteCoinDecimal, },
                config: { height: subIndicatorHeight() }, open: tiSetting.sub.RSI == true
            },
            KDJ: {
                paneId: "", name: { name: 'KDJ', precision: symbol.quoteCoinDecimal, },
                config: { height: subIndicatorHeight() }, open: tiSetting.sub.KDJ == true
            },
        }


        klineRef.current = init('kline-chart');
        const kLineChart = klineRef.current;
        kLineChart.applyNewData(kLineData);
        kLineChart.setPriceVolumePrecision(8, 2);
        // const tiMa = kLineChart.createTechnicalIndicator({
        //     name: 'MA',
        //     precision: symbol.quoteCoinDecimal,
        // }, false, { id: 'candle_pane' })
        //  kLineChart.createTechnicalIndicator({
        //     name: 'BOLL',
        //     precision: symbol.quoteCoinDecimal,
        // }, false, { id: 'candle_pane' })
        // const tiVol = kLineChart.createTechnicalIndicator('VOL', false, { height: 60 })
        // kLineChart.createTechnicalIndicator({
        //     name: 'MACD',
        //     precision: symbol.quoteCoinDecimal,
        // }, false, { height: 60 })
        // kLineChart.createTechnicalIndicator('KDJ', false, { height: 40 })

        for (const ti in technicalIndicators) {
            let conf = technicalIndicators[ti];
            if (conf.open) {
                conf.paneId = kLineChart.createTechnicalIndicator(conf.name, false, conf.config);
            }
        }

        kLineChart.setStyleOptions({
            candle: {
                type: timeRange.name == "分时" ? "area" : "candle_solid",
                margin: {
                    top: 0.25,
                },
                bar: {
                    upColor: "#2FBD85",
                    downColor: "#F6465D",
                    noChangeColor: "#888888"
                },
                tooltip: {
                    showRule: 'follow_cross',
                    showType: 'rect',
                    labels: ['', '开', '收', '高', '低', "涨跌", '量', '额   '],
                    rect: {
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingTop: 0,
                        paddingBottom: 6,
                        offsetLeft: 8,
                        offsetTop: 18,
                        offsetRight: 8,
                        borderRadius: 4,
                        borderSize: 1,
                        borderColor: '#3f4254',
                        backgroundColor: 'rgba(255,255,255)'
                    },
                    // labels: ['开 ', '收 ', '涨跌 '],
                    values: kLineData => {
                        const change = (kLineData.close - kLineData.open) / kLineData.open * 100
                        return [
                            { value: timeRange.formatTime(kLineData.timestamp) },
                            { value: kLineData.open.toFixed(symbol.quoteCoinDecimal) },
                            { value: kLineData.close.toFixed(symbol.quoteCoinDecimal) },
                            { value: kLineData.high.toFixed(symbol.quoteCoinDecimal) },
                            { value: kLineData.low.toFixed(symbol.quoteCoinDecimal) },
                            {
                                value: `${change.toFixed(2)}%`,
                                color: change < 0 ? '#F6465D' : '#2FBD85'
                            },
                            { value: kLineData.volume.toFixed(symbol.baseCoinDecimal) },
                            { value: kLineData.turnover.toFixed(symbol.quoteCoinDecimal) },
                        ]
                    },
                },
            },
            technicalIndicator: {
                tooltip: {
                    showParams: false,
                    text: {
                        size: 8,
                    }
                }
            }
        });

        return () => {
            dispose('kline-chart')
        }
    }, [loading, tiSetting])

    const onKLineUpdated = (topic, msg) => {
        const data = JSON.parse(msg.body);
        data.forEach(d => {
            const dd = toKLineData(d);
            klineRef.current.updateData(dd);
        })
    }



    let ranges = [];

    rangeField.forEach(item => {

        const txtClr = item.name == timeRange.name ? " text-black" : " text-gray-400"

        ranges.push(<div key={item.key} onClick={() => {
            setTimeRange(item)
        }}
            className={"flex items-center justify-center text-xs px-2 " + txtClr}
        >
            {item.name}
        </div>)
    });


    return <div className="h-[368px] flex justify-center items-center">
        {
            loading ? LoadingSVG
                : <div className="h-full flex flex-1 justify-center items-center flex-col">
                    <div className="flex w-full">
                        <div className="h-[24px] flex ">
                            <div className="flex h-full w-20 bg-gray-200">
                                {/* {ranges} */}
                                <Selector
                                    columns={1}
                                    //prefix="时间周期: "
                                    align="justify-center"
                                    optFontStyle={"text-xs"}
                                    options={rangeField}
                                    select={timeRange.key}
                                    onChange={e => {
                                        GlobalSetting.set("KLineTimeRangeSelected", e.key);
                                        // Global.KLineTimeRangeSelected = e.key;
                                        setTimeRange(e.value);
                                    }}
                                />
                            </div>
                        </div>
                        <div className=" h-[24px] w-[1px] bg-gray-300"></div>
                        <div className="flex h-[24px] flex-1  bg-gray-200 px-2">
                            <Selector
                                columns={2}
                                title={(prefix, selectItem, opts) => {
                                    let subTis = "";
                                    let mainTi = "无";
                                    opts.forEach(o => {
                                        if (o.type == "main") {
                                            if (o.checked) {
                                                mainTi = o.text;
                                            }
                                        } else {
                                            if (o.checked) {
                                                subTis += o.text + " ";
                                            }
                                        }
                                    });
                                    if (subTis == "") subTis = "无";

                                    return `主图：${mainTi} 副图：${subTis}`;
                                }}
                                optionType="check"
                                align="justify-start"
                                optFontStyle={"text-xs"}
                                options={techInd}
                                //select={techMainOpt.key}
                                onChange={e => {
                                    //setTechMainOpt(e.value);
                                    const item = e.value;
                                    const setting = {};
                                    setting.main = "";
                                    setting.sub = {};

                                    techInd.forEach(ti => {
                                        //主指标只能有一个被选中
                                        if (item.type == "main") {
                                            if (ti.type == "main" && ti.key != item.key) {
                                                ti.checked = false;
                                            }
                                        }

                                        if (ti.type == "main") {
                                            if (ti.checked) {
                                                setting.main = ti.text;
                                            }
                                        } else {
                                            setting.sub[ti.text] = ti.checked
                                        }
                                    });
                                    GlobalSetting.set("TechnicalIndicatorSetting", setting);
                                    // Global.TechnicalIndicatorSetting = setting;
                                    setTiSetting(setting);
                                }}
                            />
                        </div>
                    </div>
                    <div id="kline-chart" className="flex w-full h-[320px] pb-4" />
                </div>

        }
    </div>
}

function MarketSymbolDetail({ symbolSpec, onBackButtonClicked, onHidden, onShown, fireViewAction }) {
    //const [ref, { width }] = useMeasure();
    // const styles = useSpring({
    //     to: { x: move * width },
    //     onStart: {
    //         x: () => {
    //             if (move == 1) {
    //                 beforeHide();
    //             } else if (move == -1) {
    //                 beforeShow();
    //             }
    //         }
    //     },
    //     onRest: {
    //         x: () => {
    //             if (move == 1) {
    //                 onHide();
    //             } else if (move == -1) {
    //                 onShow();
    //             }
    //         }
    //     }
    // })

    const [loading, setLoading] = useState(false);
    const [plateInfo, setPlateInfo] = useState(null);
    const [currPriceStepIdx, setCurrPriceStepIdx] = useState(0);
    const [listeningPlateTopic, setListeningPlateTopic] = useState("");
    const [recentDeals, setRecentDeals] = useState([]);
    const [enabledKLine, setEnabledKLine] = useState(false);

    let { baseCoin, quoteCoin, platePriceStep } = {};

    if (symbolSpec != null) {
        baseCoin = symbolSpec.baseCoin;
        quoteCoin = symbolSpec.quoteCoin;
        platePriceStep = symbolSpec.platePriceStep;
    }

    const onPlateTopic = (topic, msg) => {
        setPlateInfo(JSON.parse(msg.body));
    }

    const requestRecentTrade = () => {
        if (symbolSpec == null) return;
        request(API.market_recentTrade(symbolSpec.id)).then(ret => {
            ret.retObject.forEach(deal => {
                let date = new Date(deal.time);
                let hour = date.getHours().toString().padStart(2, '0');
                let minute = date.getMinutes().toString().padStart(2, '0');
                let second = date.getSeconds().toString().padStart(2, '0');
                deal.time = `${hour}:${minute}:${second}`;
                recentDeals.push(deal);
                setRecentDeals(recentDeals);
            })
        })
    }

    const requestPlateInfo = (priceStep) => {
        if (symbolSpec == null) return;
        setLoading(true);
        if (priceStep == null) {
            priceStep = platePriceStep[currPriceStepIdx];
        }

        // WebSocketClient.subscribe(Topics.marketQuotePrice, (topic, msg) => {
        //     DataCenter.quotePrice = JSON.parse(msg.body);
        //     JSEvent.emit(Events.DataCenter.DATA_UPDATED, "quotePrice");
        //     console.log("===marketQuotePrice===", topic, msg.body, DataCenter.quotePrice);
        // })

        if (listeningPlateTopic != "") {
            Connections.market.unsubscribe(listeningPlateTopic)
            setListeningPlateTopic("");
        }

        request(API.market_symbolPlate(symbolSpec.id, priceStep)).then(ret => {
            setPlateInfo(ret.retObject);

            //订阅事件
            const topic = Topics.topicPlate(symbolSpec.name, priceStep);
            Connections.market.subscribe(topic, onPlateTopic);
            setListeningPlateTopic(topic);

            setLoading(false);
            console.log("setRecentDeals")
        });
    }

    useEffect(() => {
        if (symbolSpec != null)
            console.log("currPriceStepIdx changed....")
        requestPlateInfo();
    }, [currPriceStepIdx]
    )

    if (symbolSpec == null) return <div></div>

    MarketSymbolDetail.onViewEvent = event => {
        if (event.name == "opening") {
            beforeShow();
        } else if (event.name == "closing") {
            beforeHide();
        } else if (event.name == "opened") {
            setEnabledKLine(true);
        }
    }

    const beforeShow = () => {
        requestPlateInfo();
        requestRecentTrade();
        Connections.market.subscribe(Topics.topicTrade(symbolSpec.name), (topic, msg) => {
            const deals = JSON.parse(msg.body);
            deals.forEach(deal => {
                let date = new Date(deal.time);
                let hour = date.getHours().toString().padStart(2, '0');
                let minute = date.getMinutes().toString().padStart(2, '0');
                let second = date.getSeconds().toString().padStart(2, '0');
                deal.time = `${hour}:${minute}:${second}`;
                recentDeals.unshift(deal);
                if (recentDeals.length > MarketRecentDataLength) {
                    recentDeals.splice(MarketRecentDataLength)
                }
                setRecentDeals(recentDeals);
            })
        })
    }
    const beforeHide = () => {
        //隐藏界面，取消所有相关订阅
        if (listeningPlateTopic != "") {
            Connections.market.unsubscribe(listeningPlateTopic)
            setListeningPlateTopic("");
        }

        Connections.market.unsubscribe(Topics.topicTrade(symbolSpec.name));
    }

    const onShow = () => {
        if (onShown) onShown();

    }

    const onHide = () => {
        if (onHidden) onHidden();

    }


    const baseName = symbolSpec == null ? "" : symbolSpec.baseCoin.name;
    const quoteName = symbolSpec == null ? "" : symbolSpec.quoteCoin.name;
    const quoteCoinDecimal = symbolSpec == null ? 2 : symbolSpec.quoteCoinDecimal;

    const thumb = DataCenter.getCoinPairThumb(symbolSpec.id);

    const { close, lastClose, open, high, low, volume, turnover } = thumb;
    const cc = CurrentCurrency();
    let { priceChange, percentChange, percent, percentSign, currencyPrice } = DataCenter.getCoinPairCurrentState(symbolSpec);

    let priceDom = <div className={`text-2xl font-semibold text-price-up`}>{close.toFixed(quoteCoinDecimal)}</div>
    if (priceChange == "down") {
        priceDom = <div className={`text-2xl font-semibold text-price-down`}>{close.toFixed(quoteCoinDecimal)}</div>
    }

    let percentDom = <div className={`text-m pl-1 text-price-up`}> {percentSign}{percent.toFixed(2)}%</div>
    if (percentChange == "down") {
        percentDom = <div className={`text-m pl-1 text-price-down`}> {percentSign}{percent.toFixed(2)}%</div>
    }

    return <div className="w-screen h-full flex-1 flex flex-col bg-white" >
        <div className="w-full h-full flex flex-1 flex-col basis-0">
            <div className={"w-full flex flex-1 flex-col"}>
                <div className="w-full flex flex-row  pt-4">
                    <div className=' w-12 h-8 flex flex-col items-start justify-center pl-4' onClick={e => {
                        onBackButtonClicked()
                        fireViewAction({ name: "close" })
                    }}>
                        <ArrowNarrowLeftIcon className="h-6 text-gray-500 flex"
                            aria-hidden="true" /></div>
                    <div className='flex flex-1 font-semibold items-center justify-center pr-12 '>
                        {baseName}/{quoteName}
                    </div>
                </div>
                <div className="w-full flex flex-row px-4 py-1">
                    <div className="flex-1 flex flex-col justify-center">
                        {priceDom}
                        <div className="flex pt-1">
                            <div className="text-m">≈ {cc.symbol}{currencyPrice.toFixed(cc.decimals)}</div>
                            {percentDom}
                        </div>
                    </div>
                    <div className="flex flex-col text-xxs ">
                        <table >
                            <tbody>
                                <tr className="text-gray-400">
                                    <td>24h最高价</td>
                                    <td className="w-[4px]"></td>
                                    <td>24h成交量({baseCoin.name})</td>
                                </tr>
                                <tr>
                                    <td>{high.toFixed(quoteCoinDecimal)}</td>
                                    <td></td>
                                    <td>{volume}</td>
                                </tr>
                                <tr className="text-gray-400">
                                    <td>24h最低价</td>
                                    <td className="w-[4px]"></td>
                                    <td>24h成交额({quoteCoin.name})</td>
                                </tr>
                                <tr>
                                    <td>{low.toFixed(quoteCoinDecimal)}</td>
                                    <td></td>
                                    <td>{turnover.toFixed(quoteCoinDecimal)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="w-full flex-1 flex flex-col overflow-scroll basis-0">
                    <div className="w-full flex-1 flex flex-col">
                        <SymbolKLine symbol={symbolSpec} enabled={enabledKLine} />
                        {/* <div id="kline-chart" className="flex flex-col h-[400px] pb-4" ></div> */}
                        <div className="flex flex-row">
                            {
                                // klineChart == null ? <></> :
                                //     types.map(({ key, text }) => {
                                //         return (
                                //             <button className="w-10"
                                //                 key={key}
                                //                 onClick={_ => {
                                //                     klineChart.setStyleOptions({
                                //                         candle: {
                                //                             type: key
                                //                         }
                                //                     })
                                //                 }}>
                                //                 {text}
                                //             </button>
                                //         )
                                //     })
                            }
                        </div>
                        <div className="flex w-full h-2 bg-gray-100"></div>
                        <MarketPlateDetail symbolSpec={symbolSpec}
                            buyPlate={plateInfo == null ? null : plateInfo.buyPlate}
                            sellPlate={plateInfo == null ? null : plateInfo.sellPlate}
                            recentDeals={recentDeals}
                            onPlatePriceStepChanged={e => {
                                setCurrPriceStepIdx(e.index);
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
        <BottomButtons
            onClick={btn => {
                onBackButtonClicked()
                fireViewAction({ name: "close" })
                if (btn == "buy") {
                    JSEvent.emit(Events.MainMenu.SwitchMenu, { menu: "trade", args: { method: "buy", symbol: symbolSpec } });
                } else if (btn == "sell") {
                    JSEvent.emit(Events.MainMenu.SwitchMenu, { menu: "trade", args: { method: "sell", symbol: symbolSpec } });
                }
            }}
        />
        <LoadingDialog show={loading} />
    </div>
}

function MarketPlateDetail({ symbolSpec, buyPlate, sellPlate, recentDeals, onPlatePriceStepChanged }) {
    const { baseCoin, quoteCoin, platePriceStep } = symbolSpec;
    const [currPriceStepIdx, setCurrPriceStepIdx] = useState(0);
    const [currTabSel, setTabSel] = useState(0);

    useEffect(() => { }, [symbolSpec, buyPlate, sellPlate, recentDeals])

    let priceStepValues = [];
    platePriceStep.forEach(ps => {
        const v = Math.pow(10, -ps).toFixed(ps < 0 ? 0 : ps);
        priceStepValues.push(v);
    })


    const cc = CurrentCurrency();
    let { priceChange, percentChange, percent, percentSign, currencyPrice } = DataCenter.getCoinPairCurrentState(symbolSpec);

    let buyPlates = [];
    let sellPlates = [];

    if (buyPlate != null && sellPlate != null) {
        buyPlate.forEach(p => {
            buyPlates.push(
                <div className="flex w-full" key={p.price}>
                    <div className="flex flex-1 text-gray-400">{p.volume}</div>
                    <div className="flex flex-1 justify-end text-price-up pr-2">{p.price}</div>
                </div>
            )
        })
        sellPlate.forEach(p => {
            sellPlates.push(
                <div className="flex w-full" key={p.price}>
                    <div className="flex flex-1  text-price-down pl-2">{p.price}</div>
                    <div className="flex flex-1 justify-end text-gray-400">{p.volume}</div>
                </div>
            )
        })
    }

    let table = ""

    if (currTabSel == 0) {
        //盘口数据
        table = <PlateTable platePriceStep={platePriceStep}
            priceStepValues={priceStepValues}
            currPriceStepIdx={currPriceStepIdx}
            buyPlates={buyPlates}
            sellPlates={sellPlates}
            onChange={e => {
                setCurrPriceStepIdx(e.index);
                if (onPlatePriceStepChanged != null) onPlatePriceStepChanged(e);
            }
            } />
    } else if (currTabSel == 1) {
        //最新成交
        table = <DealTable recentDeals={recentDeals} />;
    }


    return <div className="flex flex-col w-full flex-1">
        <TabMenu tabItems={MarketDetailTypes} onItemChanged={(type, item) => { setTabSel(type) }} />
        <div className="flex bg-gray-100 w-full h-[1px]" />
        {table}

    </div>
}

function PlateTable({ platePriceStep, priceStepValues, currPriceStepIdx, buyPlates, sellPlates, onChange }) {
    return <div className="flex w-full px-3 flex-col">
        <div className="flex w-full ">
            <div className="flex flex-1 text-m py-2">买</div>
            <div className="flex flex-1 text-m items-center">
                卖
                <div className="flex flex-1 justify-end">
                    <div className="flex items-center p-1 rounded-md bg-gray-100">
                        <Selector
                            keys={platePriceStep}
                            values={priceStepValues}
                            select={currPriceStepIdx}
                            onChange={onChange} />
                    </div>
                </div>
            </div>
        </div>

        <div className="flex w-full h-[300px] ">
            <div className="flex flex-1 text-m flex-col">{buyPlates}</div>
            <div className="flex flex-1 text-m flex-col">{sellPlates}</div>
        </div>
    </div>
}

function DealTable({ recentDeals }) {

    let items = [];
    recentDeals.forEach(d => {
        items.push(
            <div className="flex w-full text-gray-400" key={items.length}>
                <div className="flex flex-1 text-m w-20">{d.time}</div>
                {d.action == "Buy" ?
                    <div className="flex flex-1 text-sm items-center text-price-up">{d.price}</div> :
                    <div className="flex flex-1 text-sm items-center text-price-down">{d.price}</div>
                }
                <div className="flex flex-1 text-sm items-center justify-end">{d.amount}</div>
            </div>)
    })

    return <div className="flex w-full px-3 flex-col">
        <div className="flex w-full text-gray-400">
            <div className="flex flex-1 text-m py-2 w-20">时间</div>
            <div className="flex flex-1 text-m items-center">价格</div>
            <div className="flex flex-1 text-m items-center justify-end">数量</div>
        </div>
        {items}
    </div>
}